import { render, staticRenderFns } from "./specProduct.vue?vue&type=template&id=8a2c926c&"
import script from "./specProduct.vue?vue&type=script&lang=js&"
export * from "./specProduct.vue?vue&type=script&lang=js&"
import style0 from "./specProduct.vue?vue&type=style&index=0&id=8a2c926c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports